/* THM plugin launch sections: click-to-play videos, the card animations and
   the sticky buy bar. */
(function () {
  if (window.ThmPlugins) return;
  window.ThmPlugins = true;

  /* Click-to-play: the player only loads after a click, so the page stays fast. */
  function playVideo(button) {
    var wrap = button.closest('[data-thm-video]');
    if (!wrap || wrap.classList.contains('is-playing')) return;
    var template = wrap.querySelector('template');
    var frame = wrap.querySelector('.thm-media__frame');
    if (!template || !frame) return;
    frame.appendChild(template.content.cloneNode(true));
    wrap.classList.add('is-playing');
    var video = frame.querySelector('video');
    if (video) {
      video.setAttribute('playsinline', '');
      var playing = video.play && video.play();
      if (playing && playing.catch) playing.catch(function () {});
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-thm-play]') : null;
    if (!button) return;
    event.preventDefault();
    playVideo(button);
  });

  /* Sticky buy bar: shown once the offer box at the top has scrolled out of
     view, hidden again while the pricing, the final section or the footer is
     on screen, so it never covers a buy button or the footer links. */
  var observers = [];

  function initSticky() {
    observers.forEach(function (observer) { observer.disconnect(); });
    observers = [];

    var fresh = document.querySelector('[data-thm-sticky]:not([data-thm-moved])');
    if (fresh) {
      document.querySelectorAll('[data-thm-sticky][data-thm-moved]').forEach(function (old) { old.remove(); });
      fresh.setAttribute('data-thm-moved', '');
      document.body.appendChild(fresh);
    }

    var bar = document.querySelector('[data-thm-sticky][data-thm-moved]');
    if (!bar || !('IntersectionObserver' in window)) return;

    var offer = document.querySelector('[data-thm-offer]');
    var blockers = document.querySelectorAll('[data-thm-hide-sticky], footer, .shopify-section-group-footer-group');
    var pastOffer = !offer;
    var blocking = [];

    function update() {
      var phase = document.documentElement.getAttribute('data-thm-phase');
      var show = pastOffer && blocking.length === 0 && phase !== 'before';
      bar.classList.toggle('is-on', show);
    }

    if (offer) {
      var offerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          pastOffer = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        });
        update();
      });
      offerObserver.observe(offer);
      observers.push(offerObserver);
    }

    var blockObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var index = blocking.indexOf(entry.target);
        if (entry.isIntersecting && index === -1) blocking.push(entry.target);
        if (!entry.isIntersecting && index !== -1) blocking.splice(index, 1);
      });
      update();
    });
    blockers.forEach(function (element) { blockObserver.observe(element); });
    observers.push(blockObserver);

    update();
  }

  /* Card animations: muted loops that play like GIFs, only while the card is
     on screen. Nothing loads until a card gets close, and visitors who ask for
     less motion or for data saving keep the still image. The loops are silent,
     so they stay out of the way of audio players: scripts that pause
     everything else when something starts never see a loop start, and a loop
     paused by such a script picks up again while its card is on screen. */
  var loopObserver = null;

  function playLoop(video) {
    video.muted = true;
    var started = video.play();
    if (started && started.catch) started.catch(function () {});
  }

  function loopWanted(video) {
    return video.thmOnScreen && video.isConnected && !document.hidden;
  }

  function initLoops() {
    var videos = [].slice.call(document.querySelectorAll('video[data-thm-loop]:not([data-thm-ready])'));
    if (!videos.length) return;
    videos.forEach(function (video) { video.setAttribute('data-thm-ready', ''); });

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var save = navigator.connection && navigator.connection.saveData;
    if (reduce || save) return;

    if (!window.thmLoopShield) {
      window.thmLoopShield = true;
      var shield = function (event) {
        var target = event.target;
        if (target && target.nodeType === 1 && target.hasAttribute('data-thm-loop')) event.stopImmediatePropagation();
      };
      window.addEventListener('play', shield, true);
      window.addEventListener('playing', shield, true);
    }

    videos.forEach(function (video) {
      video.addEventListener('pause', function () {
        if (video.thmOwnPause) { video.thmOwnPause = false; return; }
        if (!loopWanted(video)) return;
        var now = Date.now();
        if (now - (video.thmRetryAt || 0) > 6000) video.thmRetries = 0;
        if ((video.thmRetries || 0) >= 5) return;
        video.thmRetries = (video.thmRetries || 0) + 1;
        video.thmRetryAt = now;
        setTimeout(function () { if (video.paused && loopWanted(video)) playLoop(video); }, 300);
      });
    });

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) { video.thmOnScreen = true; playLoop(video); });
      return;
    }
    if (!loopObserver) {
      loopObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          video.thmOnScreen = entry.isIntersecting;
          if (entry.isIntersecting) { video.thmRetries = 0; playLoop(video); }
          else if (!video.paused) { video.thmOwnPause = true; video.pause(); }
        });
      }, { rootMargin: '200px 0px' });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) return;
        document.querySelectorAll('video[data-thm-loop][data-thm-ready]').forEach(function (video) {
          if (video.paused && loopWanted(video)) playLoop(video);
        });
      });
    }
    videos.forEach(function (video) { loopObserver.observe(video); });
  }

  function init() {
    initSticky();
    initLoops();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
